export const deviceStoreLinks = {
  android: "http://play.google.com/store/apps/details?id=com.campus.biomedico",
  iOS: "http://itunes.apple.com/lb/app/id1506187992",
  unknown: ""
}